let cleanup = null;

function init() {
  cleanup?.();
  cleanup = null;
  const panel = document.getElementById('DrvMegaMenu');
  if (!panel) return;
  const acEarly = new AbortController();

  const tabs = [...panel.querySelectorAll('[data-drv-mm-tab]')];
  let panes = [...panel.querySelectorAll('[data-drv-mm-panel]')];
  const promoGroups = [...panel.querySelectorAll('[data-drv-mm-promo]')];
  const selectTab = (key) => {
    tabs.forEach((t) => t.classList.toggle('is-active', t.dataset.drvMmTab === key));
    panes.forEach((p) => (p.hidden = p.dataset.drvMmPanel !== key));
    const promoGroup = promoGroups.find((g) => g.dataset.drvMmPromo === key) || promoGroups.find((g) => g.dataset.drvMmPromo === 'category');
    promoGroups.forEach((g) => (g.hidden = g !== promoGroup));
    updateThumbs?.();
    if (key === 'ingredients') loadIngredients?.();
  };

  const THUMB_H = 84;
  const updateThumb = (grid) => {
    const pane = grid.closest('[data-drv-mm-panel]');
    const thumb = pane?.querySelector('.drv-mm__thumb');
    if (!thumb) return;
    const max = grid.scrollHeight - grid.clientHeight;
    thumb.hidden = max <= 0;
    if (max <= 0) return;
    const track = thumb.parentElement.clientHeight;
    thumb.style.top = 2 + (grid.scrollTop / max) * (track - 4 - THUMB_H) + 'px';
  };
  let grids = [...panel.querySelectorAll('.drv-mm__grid')];
  const updateThumbs = () => grids.forEach(updateThumb);

  const updateDots = (group) => {
    const promo = group.querySelector('.drv-mm__mpromo');
    const dots = [...group.querySelectorAll('.drv-mm__mdot')];
    if (!promo || !dots.length || !promo.clientWidth) return;
    const i = Math.round(promo.scrollLeft / promo.clientWidth);
    dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
  };

  const wanted = (panel.dataset.triggerText || '').trim().toLowerCase();
  const header = document.querySelector('#header-component') || document.querySelector('header');
  const isTrigger = (el) => {
    const a = el instanceof Element ? el.closest('a') : null;
    return a && header?.contains(a) && a.textContent.trim().toLowerCase() === wanted ? a : null;
  };
  let trigger = null;

  const ac = new AbortController();
  const { signal } = ac;
  const blockPageScroll = (e) => {
    if (hoverMq.matches || !panel.classList.contains('is-open')) return;
    if (!e.target.closest('#DrvMegaMenu')) e.preventDefault();
  };
  document.addEventListener('touchmove', blockPageScroll, { signal, passive: false });
  document.addEventListener('wheel', blockPageScroll, { signal, passive: false });

  const bindGrid = (g) => {
    g.addEventListener('scroll', () => updateThumb(g), { signal, passive: true });
    g.addEventListener('wheel', () => setTimeout(() => updateThumb(g), 0), { signal, passive: true });
  };
  grids.forEach(bindGrid);

  let ingLoad = null;
  const loadIngredients = () => {
    const shell = panel.querySelector('[data-drv-mm-ing-src]');
    if (!shell || ingLoad) return ingLoad;
    ingLoad = fetch(shell.dataset.drvMmIngSrc, { signal })
      .then((r) => (r.ok ? r.text() : Promise.reject(new Error(String(r.status)))))
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-drv-mm-panel="ingredients"]');
        if (!fresh || fresh.hasAttribute('data-drv-mm-ing-src')) throw new Error('no ingredients');
        const inner = [...doc.querySelectorAll('[data-drv-mm-panel^="ing-inner-"]')];
        fresh.hidden = shell.hidden;
        shell.replaceWith(fresh);
        fresh.after(...inner);
        panes = [...panel.querySelectorAll('[data-drv-mm-panel]')];
        const added = [...panel.querySelectorAll('.drv-mm__grid')].filter((g) => !grids.includes(g));
        added.forEach(bindGrid);
        grids = grids.filter((g) => g.isConnected).concat(added);
        updateThumbs();
      })
      .catch(() => {
        ingLoad = null;
      });
    return ingLoad;
  };
  promoGroups.forEach((g) => {
    g.querySelector('.drv-mm__mpromo')?.addEventListener('scroll', () => updateDots(g), { signal, passive: true });
  });
  if (tabs.length) selectTab(tabs[0].dataset.drvMmTab);
  let closeTimer = null;

  const position = () => {
    const rect = header?.getBoundingClientRect();
    if (rect) panel.style.setProperty('--drv-mm-top', `${Math.max(rect.bottom, 0)}px`);
  };

  const syncBurger = (isOpen) => {
    document.querySelectorAll('summary.header__icon--menu').forEach((el) => {
      el.setAttribute('aria-expanded', String(isOpen));
      const d = el.closest('details');
      const apply = () => d?.classList.toggle('menu-open', isOpen);
      apply();
      setTimeout(apply, 0);
      setTimeout(apply, 120);
    });
  };

  const open = () => {
    document.querySelectorAll('dropdown-localization-component').forEach((el) => el.hidePanel?.());
    clearTimeout(closeTimer);
    position();
    panel.hidden = false;
    loadIngredients();
    if (!hoverMq.matches) syncBurger(true);
    const show = () => panel.classList.add('is-open');
    requestAnimationFrame(show);
    setTimeout(show, 50);
    trigger?.setAttribute('aria-expanded', 'true');
  };
  const close = () => {
    panel.classList.remove('is-open');
    trigger?.setAttribute('aria-expanded', 'false');
    if (!hoverMq.matches) syncBurger(false);
    setTimeout(() => {
      if (!panel.classList.contains('is-open')) panel.hidden = true;
    }, 250);
  };
  const delayedClose = () => {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(close, 150);
  };

  const hoverMq = matchMedia('(hover: hover) and (min-width: 1260px)');
  const searchOpen = () =>
    document.documentElement.classList.contains('drv-qs-open') ||
    !!document.querySelector('.rebuy-quick-view-dropdown__container.visible');

  window.addEventListener(
    'click',
    (e) => {
      if (hoverMq.matches) return;
      const burger = e.target.closest('summary.header__icon--menu');
      if (!burger) return;
      e.preventDefault();
      e.stopPropagation();
      panel.classList.contains('is-open') ? close() : open();
    },
    { signal: acEarly.signal, capture: true }
  );

  if (wanted) {
    document.addEventListener(
      'mouseover',
      (e) => {
        if (!hoverMq.matches || searchOpen()) return;
        const a = isTrigger(e.target);
        if (!a) {
          const other = e.target instanceof Element ? e.target.closest('a, button, summary') : null;
          if (other && header?.contains(other) && !panel.contains(other) && panel.classList.contains('is-open')) {
            clearTimeout(closeTimer);
            close();
          }
          return;
        }
        if (trigger !== a) {
          trigger = a;
          a.setAttribute('aria-haspopup', 'true');
          a.dataset.drvMmTrigger = '';
          a.closest('li')?.querySelector('.menu-list__submenu, [class*="submenu"]')?.setAttribute('hidden', '');
        }
        open();
      },
      { signal }
    );
    document.addEventListener(
      'mouseout',
      (e) => {
        if (!hoverMq.matches) return;
        if (isTrigger(e.target) && !panel.contains(e.relatedTarget)) delayedClose();
      },
      { signal }
    );
    document.addEventListener(
      'click',
      (e) => {
        const a = isTrigger(e.target);
        if (!a) return;
        e.preventDefault();
        trigger = a;
        if (!hoverMq.matches) {
          a.closest('details[open]')?.removeAttribute('open');
          a.closest('dialog[open]')?.close();
        }
        panel.classList.contains('is-open') ? close() : open();
      },
      { signal }
    );
    panel.addEventListener('mouseenter', () => clearTimeout(closeTimer), { signal });
    panel.addEventListener('mouseleave', () => { if (hoverMq.matches) delayedClose(); }, { signal });
  }

  const showTabsTop = () => {
    if (!/auto|scroll/.test(getComputedStyle(panel).overflowY)) return;
    const head = panel.querySelector('.drv-mm__mshop-head');
    if (!head) return;
    const gap = head.getBoundingClientRect().bottom - panel.getBoundingClientRect().top;
    if (gap < 0) panel.scrollTop += gap;
  };

  tabs.forEach((t) => {
    t.addEventListener('click', () => {
      selectTab(t.dataset.drvMmTab);
      showTabsTop();
    }, { signal });
    t.addEventListener('mouseenter', () => selectTab(t.dataset.drvMmTab), { signal });
  });

  panel.addEventListener(
    'click',
    (e) => {
      const card = e.target.closest('[data-drv-mm-ing]');
      if (card) {
        panes.forEach((p) => (p.hidden = p.dataset.drvMmPanel !== `ing-inner-${card.dataset.drvMmIng}`));
        updateThumbs();
        return;
      }
      if (e.target.closest('[data-drv-mm-back]')) { selectTab('ingredients'); return; }
      const gh = e.target.closest('[data-drv-mm-group]');
      if (gh && !hoverMq.matches && !e.target.closest('a')) {
        gh.parentElement.classList.toggle('is-m-open');
        return;
      }
      const shopHead = e.target.closest('[data-drv-mm-shop]');
      if (shopHead) {
        const collapsed = panel.classList.toggle('is-shop-collapsed');
        shopHead.setAttribute('aria-expanded', String(!collapsed));
        return;
      }
      const rowHead = e.target.closest('[data-drv-mm-row]');
      if (rowHead) {
        const row = rowHead.parentElement;
        const open = row.classList.toggle('is-m-open');
        rowHead.setAttribute('aria-expanded', String(open));
      }
    },
    { signal }
  );

  document.addEventListener(
    'keydown',
    (e) => {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
    },
    { signal }
  );
  document.addEventListener(
    'click',
    (e) => {
      if (panel.classList.contains('is-open') && !panel.contains(e.target) && e.target !== trigger && !trigger?.contains(e.target)) close();
    },
    { signal }
  );
  window.addEventListener('resize', position, { signal });

  cleanup = () => {
    clearTimeout(closeTimer);
    ac.abort();
    acEarly.abort();
  };
}

init();
document.addEventListener('shopify:section:load', init);
document.addEventListener('shopify:section:unload', (e) => {
  if (e.target.contains(document.getElementById('DrvMegaMenu'))) cleanup?.();
});
